import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18 15.5L12.5 10 7 15.5" stroke="currentColor" fill="none" /></svg>;